<template>
  <div class="w-full max-w-sm border border-border rounded-ds-lg p-5">
    <DSPeriodScrollerSettings
      :timeline
      :disabled
      simple-view
      @apply="handleApply($event, timeline, handleUpdateTimeline)"
    />
  </div>
</template>

<script setup lang="ts">
import type { RepositoryTimeline, TimelineDraft } from '@types'

import { useTimeline } from '../../../hooks/useTimeline'

import { DSPeriodScrollerSettings } from '@ds'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const { timeline, handleUpdateTimeline } = useTimeline()

const handleApply = async (
  draft: TimelineDraft, 
  timeline: RepositoryTimeline, 
  callback: (draft: RepositoryTimeline, isEndChanged: boolean) => Promise<void>
) => {
  const isEndChanged =
    draft.end !== timeline.end || draft.end_is_today !== timeline.end_is_today
  callback({
    ...timeline,
    ...draft,
  }, isEndChanged)
}
</script>
